function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, onMounted, ref, watch, getCurrentInstance } from "vue";
import SearchBar from "@/components/SearchV3/index.vue";
import TableList from "@/components/TableList/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import searchMixin from "@/mixin/search";
import _ from "lodash";
import qs from "qs";
import { v2Host } from "@/config/host";
import { cookRequestParams } from "@/common/request";
import { billingMaterialList } from "@/api/grant/grant";
import { _default, formItemList, _tableColumnConfig, getSearchProjects, getSearchOptions } from "../config/bill";
export default defineComponent({
    components: {
        SearchBar: SearchBar,
        TableList: TableList,
        Pagination: Pagination
    },
    mixins: [
        searchMixin
    ],
    setup: function setup(props) {
        var getParams = function getParams() {
            var new_params = _.cloneDeep(query.value);
            if (new_params.adv_id !== undefined && new_params.adv_id !== "") {
                new_params.adv_id = Number(new_params.adv_id);
                if (isNaN(new_params.adv_id)) {
                    root.$message.error("\u5E7F\u544A\u4E3Bid\u5FC5\u987B\u586B\u5199\u6570\u5B57");
                    return false;
                }
            }
            return _objectSpreadProps(_objectSpread({}, _.pick(new_params, [
                "page_size",
                "page",
                "adv_id",
                "keyword",
                "time",
                "adv_ids",
                "project_ids",
                "basic_ids",
                "is_test",
                "status",
                "search_field", 
            ])), {
                stop_time_begin: new_params.stop_time[0],
                stop_time_end: new_params.stop_time[1]
            });
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var listLoading = ref(false);
        var list = ref([]);
        var total = ref(1);
        var query = ref(_objectSpread({}, _default));
        var tableColumnConfig = computed(function() {
            return _tableColumnConfig;
        });
        function initList() {
            return _initList.apply(this, arguments);
        }
        function _initList() {
            _initList = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var params, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            params = getParams();
                            if (params) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            listLoading.value = true;
                            _ctx.next = 7;
                            return billingMaterialList(params);
                        case 7:
                            res = _ctx.sent;
                            listLoading.value = false;
                            list.value = _.get(res, "data.data.list") || [];
                            total.value = _.get(res, "data.data.total");
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            listLoading.value = false;
                            console.log(_ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return _initList.apply(this, arguments);
        }
        function exportSheet() {
            return _exportSheet.apply(this, arguments);
        }
        function _exportSheet() {
            _exportSheet = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var params, path;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            params = getParams();
                            if (params) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            path = "".concat(v2Host, "/grant/billing-material?").concat(qs.stringify(cookRequestParams(_objectSpreadProps(_objectSpread({}, params), {
                                export: 1
                            }))));
                            window.open(path, "_blank");
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return _exportSheet.apply(this, arguments);
        }
        onMounted(function() {
            query.value.status = query.value.status.map(function(t) {
                return String(t);
            });
            initList();
            getSearchProjects(" ");
            getSearchOptions(" ");
        });
        watch(function() {
            return root.$route;
        }, function(to, from) {
            query.value.status = query.value.status.map(function(t) {
                return String(t);
            });
            initList();
        });
        return {
            query: query,
            listLoading: listLoading,
            list: list,
            formItemList: formItemList,
            tableColumnConfig: tableColumnConfig,
            total: total,
            initList: initList,
            exportSheet: exportSheet
        };
    }
});
